import { type ApiTemplateCustomization } from '@Model';
import { memo, type FC } from 'react';
import { Customization, type CustomizationUpdater } from '.';
import { type GroupedCustomization, type ProcessedCustomization } from './customizationGrouping';
import { customizationHasValue, getKey } from './customizationUtils';
import { useOrderedCustomizations } from './useOrderedCustomizations';

interface CustomizationGroupProps {
    customizations: GroupedCustomization[];
    locked?: boolean;
    updateData: CustomizationUpdater;
}

export const CustomizationGroup: FC<CustomizationGroupProps> = memo(function CustomizationGroup({
    customizations,
    locked,
    updateData,
}) {
    const [main, offset, ...others] = useOrderedCustomizations(customizations);
    const showOffset = offset && (main ? customizationHasValue(main as ApiTemplateCustomization) : true);

    return (
        <>
            {main && <Customization data={main} locked={locked} updateData={updateData} />}
            {showOffset && <Customization data={offset} locked={locked} updateData={updateData} />}
            {others.map(
                (customization) =>
                    customization && (
                        <Customization
                            key={getKey(customization as ProcessedCustomization)}
                            data={customization}
                            locked={locked}
                            updateData={updateData}
                        />
                    ),
            )}
        </>
    );
});
